import { FeatureFlag } from '../FeatureFlag';

export const enableInAppHelp = new FeatureFlag({
    key: 'enable-in-app-help',
    createdOn: '2026-04-09',
    defaultValue: false,
});
